// extracted by mini-css-extract-plugin
module.exports = {"cross":"dialog_cross__3fyMU","crossPlaceHolderSmall":"dialog_crossPlaceHolderSmall__3h4wz","crossPlaceHolderLarge":"dialog_crossPlaceHolderLarge__1gbTk","transparentBg":"dialog_transparentBg__3csY0"};
    if(module.hot) {
      // 1790670235054
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  